import React, { useEffect } from 'react'
import { CollapsibleListButton } from '../Collapsible/CollapsibleListButton'
import { ALWAYS_VISIBLE_COUNT, useCollapsibleList } from '../Collapsible/useCollapsibleList'
import { getSelectedWithToggle } from '../CheckListFilter/CheckListFilter'
import { Divider, Flex, Link, Text } from 'chemistry'
import { FaChevronRight } from 'react-icons/fa'
import classNames from 'classnames'

function ListItem({ value, label, count, href, className, onClick, shouldHideDivider, isDropdownFilter }) {
  return (
    <div key={value} {...(className ? { className } : {})}>
      {!shouldHideDivider && isDropdownFilter && <Divider my='4px' />}
      <Link
        w='100%'
        href={href}
        onClick={onClick}
        data-testid='list-item'
        data-value={value}
        textDecoration='none'
        color='grey.900'
        _hover={{ textDecoration: 'underline' }}
        {...(isDropdownFilter ? { py: '8px' } : {})}
      >
        <Flex justifyContent='space-between' alignItems='center'>
          <Text>
            {label}{' '}
            {count && (
              <Text as='span' color='grey.600'>
                {`(${count})`}
              </Text>
            )}
          </Text>
          {isDropdownFilter && <FaChevronRight />}
        </Flex>
      </Link>
    </div>
  )
}

function ListItems({ items, onSelect, isAtTheTop, shouldPreventDefault, isDropdownFilter }) {
  return items.map((item, index) => (
    <ListItem
      {...item}
      onClick={e => onSelect({ e, item, shouldPreventDefault })}
      shouldHideDivider={isAtTheTop && index === 0}
      isDropdownFilter={isDropdownFilter}
    />
  ))
}

const showItem = show => item => ({ ...item, className: classNames({ 'display-none': !show }) })
export function ListFilterItems({
  filter: { title, name, items, type },
  preventClick,
  onChange,
  buttonActiveText,
  buttonInactiveText,
  isDropdownFilter = false,
  isParentCollapsed,
  className,
  filterPosition,
  id
}) {
  const alwaysVisibleCount = isDropdownFilter ? 9999 : ALWAYS_VISIBLE_COUNT
  const { stickyItems, collapsibleItems, isListCollapsed, toggleCollapsedList, setCollapsibleItems } =
    useCollapsibleList({
      items,
      isParentCollapsed,
      alwaysVisibleCount
    })

  useEffect(() => {
    setCollapsibleItems(items => items.map(showItem(!isListCollapsed)))
  }, [isListCollapsed, setCollapsibleItems])

  const onSelect = ({ e, item, shouldPreventDefault }) => {
    if (shouldPreventDefault) e?.preventDefault()
    const { selectedItems, wasItemPresent } = getSelectedWithToggle(items, item)

    if (!wasItemPresent) selectedItems.push(item)
    onChange({
      name,
      items: selectedItems,
      item: { ...item, checked: !item.checked },
      type,
      title,
      filterPosition
    })
  }

  return (
    <div className={classNames('flex flex-column', className)} id={id}>
      <ListItems
        items={stickyItems}
        isAtTheTop
        onSelect={onSelect}
        shouldPreventDefault={preventClick}
        isDropdownFilter={isDropdownFilter}
      />
      {collapsibleItems?.length > 0 && (
        <>
          <ListItems
            items={collapsibleItems}
            onSelect={onSelect}
            shouldPreventDefault={preventClick}
            isDropdownFilter={isDropdownFilter}
          />
          {isDropdownFilter && <Divider my='4px' />}
          <CollapsibleListButton
            {...(isDropdownFilter ? { py: '8px' } : {})}
            onClick={e => {
              toggleCollapsedList(e)
              document.querySelector(`#${id} *:nth-child(${alwaysVisibleCount}) a`).focus()
            }}
          >
            {isListCollapsed ? buttonInactiveText : buttonActiveText}
          </CollapsibleListButton>
        </>
      )}
    </div>
  )
}
